import React, { useState, useEffect } from 'react';
import {
  Card, Button, Modal, Col, Form, Row,
} from 'react-bootstrap';
import Select from 'react-select';
import './ModalGrantAccessToFolder.less';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Stack from '@mui/material/Stack';
import Search from '@material-ui/icons/Search';
import UserCard from '../../UserCard';
import api from '../../../api';
import useToast from '../../../hooks/useToast';
import DraggableModal from '../DraggableModal';

export default function ModalGrantAccessToFolder(props) {
  const {
    onClose, onConfirm, headerText, accessType, visibleAccessType, parentId, id, external,
  } = props;
  const [loading, setLoading] = useState(false);
  const [showSpecialSwitchMode, setShowSpecialSwitchMode] = useState(true);
  const [checkTest, setCheckTest] = useState();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const [searchValue, setSearchValue] = useState();
  const [permsData, setPermsData] = useState([]);
  const [firstInitialValues, setFirstInitialValues] = useState([]);
  const addToast = useToast();

  const radioData = [
    { title: 'Всем сотрудникам УрФУ', type: 'allUrFU' },
    { title: 'Выбрать ФИО', type: 'fio' },
    { title: 'Скрыть папку от всех', type: 'hideAll' },
    { title: 'Наследуются права родительской папки', type: 'parent' },
  ];

  const permsOptions = [
    { label: 'Просмотр', value: 'read' },
    { label: 'Редактирование', value: 'write' },
  ];

  const colourStyles = {
    control: (styles, { isFocused }) => {
      return {
        ...styles,
        boxShadow: isFocused ? '0 0 0 4px #CADBFC' : 'none',
        borderColor: isFocused ? '#CADBFC' : 'hsl(0, 0%, 80%)',
        '&:hover': {
          borderColor: isFocused ? '#CADBFC' : 'hsl(0, 0%, 80%)'}
      }
    },
  }

  const [switchMode, setSwitchMode] = useState(permsOptions[0]);
  const [switchUniqueModes, setSwitchUniqueModes] = useState([]);

  const getDisplayName = (item) => `${item.lastName || ''} ${item.firstName || ''} ${item.middleName || ''}`;

  const handleConfirm = async () => {
    setLoading(true);
    let result = {};
    if (checkTest === 'parent') {
      result = await api.post('/folderPermissions/unsetFolderAccessType', { folderId: id.toString() });
      if (!result || result.error) addToast.error(result?.error?.message || 'Ошибка запроса');
      else addToast.success('Права унаследованы');
      onConfirm(id, checkTest, switchMode);
    }
    if (checkTest === 'hideAll') {
      result = await api.post('/folderPermissions/makeFolderPrivate', { folderId: id.toString() });
      if (!result || result.error) addToast.error(result?.error?.message || 'Ошибка запроса');
      else addToast.success('Папка успешно скрыта от всех');
      onConfirm(id, checkTest, switchMode);
    }
    if (checkTest === 'allUrFU') {
      result = await api.post('/folderPermissions/makeFolderPublic', { folderId: id.toString(), perm: switchMode.value });
      if (!result || result.error) addToast.error(result?.error?.message || 'Ошибка запроса');
      else if (switchMode.value === 'read') addToast.success('Доступ к просмотру папки предоставлен всем сотрудникам УрФУ');
      else if (switchMode.value === 'write') addToast.success('Доступ к редактированию папки предоставлен всем сотрудникам УрФУ');
      onConfirm(id, checkTest, switchMode);
    }
    if (checkTest === 'fio') {
      const exceptionSwitchMode = switchMode.value === 'read' ? 'write' : 'read';
      const selectedE = selectedEmployees?.map((e) => e?.sAMAccountName).concat(switchUniqueModes?.filter((e) => e?.value === switchMode.value).map((e) => e?.sAMAccountName));
      const otherSelectedE = switchUniqueModes?.filter((e) => e?.value !== switchMode.value).map((e) => e?.sAMAccountName);
      const changedValues = switchUniqueModes?.map((e) => e?.sAMAccountName);
      const toSave = initialValues?.map((e) => e?.sAMAccountName);
      const toDelete = firstInitialValues?.filter((e) => !toSave?.includes(e.sAMAccountName)).map((e) => e?.sAMAccountName);
      if (changedValues?.length) {
        const req = await api.del('/folderPermissions', { users: changedValues, folderId: id.toString() });
        if (!req || req.error) addToast.error(req?.error?.message || 'Ошибка запроса');
      }
      if (toDelete?.length) {
        const req = await api.del('/folderPermissions', { users: toDelete, folderId: id.toString() });
        if (!req || req.error) addToast.error(req?.error?.message || 'Ошибка запроса');
        else addToast.success('Права удалены');
      }
      if (selectedE?.length) {
        result = await api.post('/folderPermissions/makeFolderRestricted', { users: selectedE, folderId: id.toString(), perm: switchMode.value });
        if (!result || result.error) addToast.error(result?.error?.message || 'Ошибка запроса');
        else if (switchMode.value === 'read') addToast.success('Доступ к просмотру папки предоставлен выбранным сотрудникам УрФУ');
        else if (switchMode.value === 'write') addToast.success('Доступ к редактированию папки предоставлен выбранным сотрудникам УрФУ');
      }
      if (otherSelectedE?.length) {
        const second = await api.post('/folderPermissions/makeFolderRestricted', { users: otherSelectedE, folderId: id.toString(), perm: exceptionSwitchMode });
        if (!second || second.error) addToast.error(second?.error?.message || 'Ошибка запроса');
        else if (exceptionSwitchMode === 'read') addToast.success('Доступ к просмотру папки предоставлен выбранным сотрудникам УрФУ');
        else if (exceptionSwitchMode === 'write') addToast.success('Доступ к редактированию папки предоставлен выбранным сотрудникам УрФУ');
      }
      onConfirm(id, checkTest, switchMode);
    }
    if (result) onClose();
    setLoading(false);
  };

  useEffect(async () => {
    const value = external?.find((e) => e.id === id);
    showSpecialSwitchMode
      ? external?.find((e) => e.id === id) ? setSwitchMode(value.switch2) : setSwitchMode(accessType === 'public' ? permsOptions[1] : permsOptions[0])
      : setSwitchMode(permsOptions[0]);
    setShowSpecialSwitchMode(false);
  }, [checkTest]);

  useEffect(async () => {
    permsData && setInitialValues(permsData.write?.map((e) => ({ ...e, status: 'Редактирование', statusId: 'write' }))?.concat(permsData.read?.map((e) => ({ ...e, status: 'Просмотр', statusId: 'read' }))));
    permsData && setFirstInitialValues(permsData.write?.map((e) => ({ ...e, status: 'Редактирование', statusId: 'write' }))?.concat(permsData.read?.map((e) => ({ ...e, status: 'Просмотр', statusId: 'read' }))));
    if (external?.find((e) => e.id === id)) {
      const value = external.find((e) => e.id === id);
      setCheckTest(value.switch1);
    } else if (accessType) {
      if (accessType === 'private') {
        if (permsData?.read?.length || permsData?.write?.length) {
          setCheckTest(radioData[1].type);
        } else {
          setCheckTest(radioData[2].type);
        }
      }
      if (visibleAccessType === 'readonly' || visibleAccessType === 'public') {
        if (permsData?.read?.length || permsData?.write?.length) {
          setCheckTest(radioData[1].type);
        } else if (parentId === 1) {
          setCheckTest(radioData[0].type);
        }
      }
      if (accessType === 'readonly' || accessType === 'public') {
        if (permsData?.read?.length || permsData?.write?.length) {
          setCheckTest(radioData[1].type);
        } else {
          setCheckTest(radioData[0].type);
        }
      } else if (accessType === null) {
        setCheckTest(radioData[3].type);
      }
    } else if (parentId === 1) setCheckTest(radioData[0].type);
    else setCheckTest(radioData[3].type);
  }, [permsData]);

  useEffect(async () => {
    getOptions(searchValue);
  }, [searchValue, initialValues, switchMode]);

  useEffect(async () => {
    const result = await api.get('/folderPermissions');
    setPermsData(result[id]);
  }, []);

  const handleEmployeeSelect = (el) => {
    selectedEmployees.find((e) =>
      e.sAMAccountName === el.sAMAccountName,
    )
      ? setSelectedEmployees(selectedEmployees.filter((e) =>
        e.sAMAccountName !== el.sAMAccountName,
      ))
      : setSelectedEmployees((selectedEmployees) => [...selectedEmployees, el]);
  };

  const getOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      return [];
    }
    let result = await api.get(`/users?name=${inputValue.trim()}`);
    const initialSams = initialValues?.map((e) => e.sAMAccountName);
    result = result.filter((e) => !initialSams?.includes(e.sAMAccountName));
    setEmployees(result);
  };

  return (
    <DraggableModal size="lg" show headerNode={headerText} onHide={onClose}>
      <Modal.Body className="grant-access">
        <Row className="mb-1">
          <Col>Предоставить доступ к просмотру или редактированию</Col>
        </Row>
        <Row className="mb-1">
          <Form.Group as={Col}>
            {parentId !== 1 && (
              <div className="simple-radio-container ">
                <Form.Check
                  type="radio"
                  key={radioData[3].type}
                  value={radioData[3].type}
                  label={radioData[3].title}
                  onChange={() => setCheckTest(radioData[3].type)}
                  checked={checkTest === radioData[3].type}
                />
              </div>
            )}
            <div className="simple-radio-container radio-container">
              <Form.Check
                type="radio"
                key={radioData[0].type}
                value={radioData[0].type}
                label={radioData[0].title}
                onChange={() => setCheckTest(radioData[0].type)}
                checked={checkTest === radioData[0].type}
              />
              {checkTest === radioData[0].type
                  && (
                  <Select
                    defaultValue={switchMode}
                    name="param"
                    className='select-perm'
                    options={permsOptions}
                    onChange={(e) => setSwitchMode(e)}
                    styles={colourStyles}
                  />
                  )}
            </div>
            <div className="radio-container">
              <Form.Check
                type="radio"
                key={radioData[2].type}
                value={radioData[2].type}
                label={radioData[2].title}
                onChange={() => setCheckTest(radioData[2].type)}
                checked={checkTest === radioData[2].type}
              />
            </div>
            <div className="radio-container">
              <Form.Check
                type="radio"
                key={radioData[1].type}
                value={radioData[1].type}
                label={radioData[1].title}
                onChange={() => setCheckTest(radioData[1].type)}
                checked={checkTest === radioData[1].type}
              />
              {checkTest === radioData[1].type
                  && (
                  <Card className="card-wrapper">
                    <Card.Body className="p-4">
                      <Row>
                        <Form.Group>
                          <div className="simple-radio-container">
                            <Stack
                              component="form"
                              sx={{
                                width: '68%',
                                marginLeft: '4px'
                              }}
                              spacing={2}
                              noValidate
                              autoComplete="off"
                            >
                              <TextField
                                hiddenLabel
                                id="standard-search"
                                label=""
                                placeholder="ФИО"
                                value={searchValue || ''}
                                type="text"
                                variant="standard"
                                onKeyPress={(e) => {
                                  if (e.key === 'Enter') {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => setSearchValue(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Search />
                                    </InputAdornment>
                                  ),
                                  endAdornment: searchValue && (
                                  <InputAdornment
                                    style={{ cursor: 'pointer', marginRight: '7px' }}
                                    onClick={() => {
                                      setSearchValue('');
                                      setEmployees([]);
                                    }}
                                  >
                                    <div className="btn-close" />
                                  </InputAdornment>
                                  ),
                                }}
                              />
                            </Stack>
                            <Select
                              defaultValue={switchMode}
                              name="param"
                              className='select-perm'
                              options={permsOptions}
                              onChange={(e) => setSwitchMode(e)}
                              styles={colourStyles}
                            />
                          </div>
                          <div className="list-employees-wrapper">
                            {Object.keys(employees)?.map((e) => (
                              <Form.Check
                                type="checkbox"
                                key={employees[e].sAMAccountName}
                                className="person-checkbox"
                                value={
                                            employees[e].sAMAccountName
                                            // (employees[e].employeeId && employees[e].id)
                                            // ? employees[e].employeeId : employees[e].employeeId
                                            // ? employees[e].employeeId : employees[e].id
                                          }
                                label={<UserCard displayName={getDisplayName(employees[e])} job={employees[e].post} />}
                                onChange={() => handleEmployeeSelect(employees[e])}
                                checked={selectedEmployees.find((el) =>
                                  employees[e].sAMAccountName === el.sAMAccountName,
                                  // (el.employeeId && el.id)
                                  // ? el.employeeId === employees[e].employeeId : employees[e].employeeId
                                  // ? el.employeeId === employees[e].employeeId : el.id === employees[e].id
                                )}
                              />
                            ))}
                            {initialValues?.length
                              ? (
                                <div style={{ marginTop: '36px' }}>
                                  <p style={{
                                    fontWeight: '600', fontSize: '18px', lineHeight: '20px', marginBottom: '24px', marginLeft: '4px'
                                  }}
                                  >
                                    Пользователи, имеющие доступ
                                  </p>
                                  <div>
                                    {Object.keys(initialValues).map((e) => (
                                      <div key={initialValues[e].sAMAccountName} className="simple-radio-container">
                                        <Form.Check
                                          type="checkbox"
                                          className="person-checkbox"
                                          value={
                                                  initialValues[e].sAMAccountName
                                                }
                                          label={<UserCard displayName={getDisplayName(initialValues[e])} job={initialValues[e].post} />}
                                          onChange={(el) => setInitialValues(initialValues.filter((e) => el.target.value !== e.sAMAccountName))}
                                          checked={initialValues.find((el) =>
                                            initialValues[e].sAMAccountName === el.sAMAccountName)}
                                        />
                                        <Select
                                          defaultValue={{ label: initialValues[e].status, value: initialValues[e].statusId }}
                                          name="param"
                                          className='select-perm type2'
                                          options={permsOptions}
                                          onChange={(el) => { el.sAMAccountName = initialValues[e].sAMAccountName, setSwitchUniqueModes(switchUniqueModes.filter((i) => i.sAMAccountName !== el.sAMAccountName).concat(el)); }}
                                          styles={colourStyles}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )
                              : null}
                          </div>
                        </Form.Group>
                      </Row>
                    </Card.Body>
                  </Card>
                  )}
            </div>
          </Form.Group>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={onClose}
          variant="outline-secondary"
          disabled={loading}
        >
          Отмена
        </Button>
        <Button
          onClick={handleConfirm}
          variant={props.confirmBtnVariant || 'primary'}
          disabled={loading}
        >
          {props.confirmBtnText || 'Да'}
        </Button>
      </Modal.Footer>
    </DraggableModal>
  );
}
